import DeleteIcon from '@mui/icons-material/Delete';
import {
  Avatar,
  IconButton,
  TableCell,
  TableRow,
  TableContainer,
  Table,
  TableBody,
  TablePagination,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledComponent } from 'src/components/styled-components/styledComponent';
import { UserListHead } from 'src/sections/@dashboard/user';

const OrganizationBrandTable = ({
  brandList,
  rowsPerPage,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  handleBrandStatus,
  handleDelete,
}) => {
  const { t: translate } = useTranslation();
  return (
    <>
      <TableContainer
        sx={{
          minHeight: 'calc(100vh - 305px)',
          maxHeight: 'calc(100vh - 305px)',
        }}
      >
        <Table stickyHeader>
          <UserListHead
            headLabel={[
              { id: 'profile', label: translate('navbar.menu.profile'), alignCenter: false },
              { id: 'brand name', label: translate('brand.brand_name'), alignRight: false },
              {
                id: 'brand description',
                label: translate('manage_brand.brand_info.brand_description'),
                alignRight: false,
              },
              { id: 'status', label: translate('common.status'), alignCenter: true },
              { id: 'delete', label: translate('common.delete'), alignCenter: true },
            ]}
            rowCount={brandList.length}
            isShowCheckbox={false}
          />
          <TableBody>
            {brandList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((brand, index) => (
              <TableRow hover key={brand.brand_id} tabIndex={-1}>
                <TableCell component="th" scope="row" sx={{ py: 3 }}>
                  <Avatar
                    src={brand.brand_image ? brand.brand_image : brand.brand_name.charAt(0).toUpperCase()}
                    alt={brand.brand_name ? brand.brand_name.charAt(0).toUpperCase() : brand.brand_id}
                    sx={{ height: 40, width: 40, bgcolor: 'primary.main', color: '#ffffff' }}
                  />
                </TableCell>
                <TableCell align="left">{brand.brand_name}</TableCell>
                <TableCell align="left">{brand.description}</TableCell>
                <TableCell align="center">
                  {' '}
                  <StyledComponent.SwitchIcon
                    sx={{ m: 2 }}
                    checked={brand.is_enabled}
                    onClick={() => {
                      handleBrandStatus(brand, index);
                    }}
                  ></StyledComponent.SwitchIcon>
                </TableCell>
                <TableCell align="center">
                  <IconButton
                    size="large"
                    onClick={() => {
                      handleDelete(brand.brand_id);
                    }}
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        rowsPerPageOptions={[10, 15, 25]}
        count={brandList.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default OrganizationBrandTable;
